__turbopack_context__.v({
  "headline": "Legend-module-scss-module__wZ0KKG__headline",
  "icon": "Legend-module-scss-module__wZ0KKG__icon",
  "root": "Legend-module-scss-module__wZ0KKG__root",
});
